import { IonTabButton } from '@ionic/react';
import { Order } from '../../../../../../../services/exports/Interfaces';
import Button from '../../../../../components/buttons/Button';
import OrderItem from './OrderItem';
import { Tabs } from '../../../../../exports/Enums';
import { useTranslation } from 'react-i18next';

interface OrdersProps {
  data: Order[];
}

const Orders = ({ data }: OrdersProps) => {
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Pages:Tabs:Orders:Components:Orders' });

  if (data?.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center gap-y-sm h-full">
        <h4 className="text-center">{t('title')}</h4>
        <p className="text-brand-text-secondary text-center mb-2">{t('description')}</p>
        <div className="w-full">
          <IonTabButton tab={Tabs.Menu} className="w-full">
            <Button title={t('buttons.order_now')} />
          </IonTabButton>
        </div>
      </div>
    );
  }
  return (
    <>
      {data?.map((order) => (
        <OrderItem key={order.id} data={order}>
          <OrderItem.DetailsBtn data={order} />
        </OrderItem>
      ))}
    </>
  );
};

export default Orders;
